module.exports = __webpack_public_path__ + "media/images/flags/4x3/jor-3abd5f5ecba1c4a0881e2c214358cdd4.svg";